module.exports = __webpack_public_path__ + "img/icon.6b5744c1.png";